module.exports = __webpack_public_path__ + "media/fonts/brand-icons-a06da7f0.woff2";